/* eslint-disable no-plusplus */
/* eslint-disable react/react-in-jsx-scope */
import React from 'react'

import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(() => ({
  paginationContainer: {
    display: 'flex',
    justifyContent: 'center',
    gap: 8,
    marginTop: 24,
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  button: {
    minWidth: 32,
    height: 32,
    padding: '0 12px',
    fontSize: 14,
    border: '1px solid #ccc',
    borderRadius: 20,
    backgroundColor: '#fff',
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out',
    fontWeight: 500,
    '&:hover': {
      backgroundColor: '#eee',
    },
  },
  active: {
    backgroundColor: '#6366f1',
    color: '#fff',
    border: '1px solid #6366f1',
  },
  textBold: {
    fontWeight: 600,
  },
  arrow: {
    fontSize: 14,
  },
}))

export default function Pagination({ page, totalPages, onPageChange }) {
  const classes = useStyles()

  const handlePageClick = (newPage) => {
    if (newPage !== page && newPage > 0 && newPage <= totalPages) {
      onPageChange(newPage)
    }
  }

  const getDisplayedPages = () => {
    const delta = 1

    const range = []
    for (let i = Math.max(2, page - delta); i <= Math.min(totalPages - 1, page + delta); i++) {
      range.push(i)
    }

    if (page - delta > 2) {
      range.unshift('...')
    }

    if (page + delta < totalPages - 1) {
      range.push('...')
    }

    range.unshift(1)
    if (totalPages > 1) range.push(totalPages)

    return range
  }

  return (
    <>
      <div className={classes.paginationContainer}>
        {page > 1 && (
          <>
            <button
              type="button"
              className={classes.button}
              onClick={() => handlePageClick(page - 1)}
            >
              <span className={classes.arrow}>‹</span>
              <span className={classes.textBold}>Anterior</span>
            </button>

            <button type="button" className={classes.button} onClick={() => handlePageClick(1)}>
              «
            </button>
          </>
        )}
        {getDisplayedPages().map((p, index) => (
          <button
            key={index}
            type="button"
            disabled={p === '...'}
            onClick={() => typeof p === 'number' && handlePageClick(p)}
            className={`${classes.button} ${p === page ? classes.active : ''}`}
          >
            {p}
          </button>
        ))}

        {page < totalPages && (
          <>
            <button
              type="button"
              className={classes.button}
              onClick={() => handlePageClick(totalPages)}
            >
              »
            </button>

            <button
              type="button"
              className={classes.button}
              onClick={() => handlePageClick(page + 1)}
            >
              <span className={classes.textBold}>Siguiente</span>
              <span className={classes.arrow}>›</span>
            </button>
          </>
        )}
      </div>
    </>
  )
}
